/** @ngInject */
export default function endpointsService($http) {
  const URL_BASE = 'oc-api/operations/web-hooks';

  return {
    getEndpoints,
    getAvailableNotificationTypes,
    update,
    remove,
  };

  function getEndpoints(notificationSystemId) {
    return $http.get(`${URL_BASE}/${notificationSystemId}/endpoints`);
  }

  function getAvailableNotificationTypes() {
    return $http.get(`${URL_BASE}/endpoints/notification-types`);
  }

  function update(notificationSystemId, endpoint) {
    return $http.put(`${URL_BASE}/${notificationSystemId}/endpoints/${endpoint.id}`, endpoint);
  }

  function remove(notificationSystemId, endpointId) {
    return $http.delete(`${URL_BASE}/${notificationSystemId}/endpoints/${endpointId}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/webhooks/endpoints/endpoints.service.js